var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalLeaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 16.5H38.5M12.8333 5.5V9.16667M31.1667 5.5V9.16667M21.9956 23.3051C20.7126 21.8768 18.5733 21.4925 16.9659 22.8006C15.3585 24.1085 15.1322 26.2955 16.3945 27.8425C17.1072 28.7159 18.8005 30.2469 20.1399 31.4147C20.7752 31.9686 21.0927 32.2456 21.4769 32.3589C21.8046 32.4555 22.1866 32.4555 22.5143 32.3589C22.8985 32.2456 23.2161 31.9686 23.8513 31.4147C25.1907 30.2469 26.884 28.7159 27.5966 27.8425C28.8591 26.2955 28.6603 24.0948 27.0254 22.8006C25.3902 21.5063 23.2786 21.8768 21.9956 23.3051ZM11.3667 38.5H32.6333C34.6868 38.5 35.7137 38.5 36.498 38.1003C37.1879 37.7489 37.7489 37.1879 38.1003 36.498C38.5 35.7137 38.5 34.6868 38.5 32.6333V15.0333C38.5 12.9798 38.5 11.953 38.1003 11.1687C37.7489 10.4788 37.1879 9.91784 36.498 9.56631C35.7137 9.16667 34.6868 9.16667 32.6333 9.16667H11.3667C9.31315 9.16667 8.28637 9.16667 7.50204 9.56631C6.8121 9.91784 6.25117 10.4788 5.89965 11.1687C5.5 11.953 5.5 12.9798 5.5 15.0333V32.6333C5.5 34.6868 5.5 35.7137 5.89965 36.498C6.25117 37.1879 6.8121 37.7489 7.50204 38.1003C8.28637 38.5 9.31313 38.5 11.3667 38.5Z",
    stroke: "#3B82F6",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalLeaves);
export default __webpack_public_path__ + "static/media/totalLeaves.9d077536497b7bc16a4dc435e5408146.svg";
export { ForwardRef as ReactComponent };